/**
 * Default parameter values for KB Upload
 */
export const kbUploadDefaults = {
  collectionId: '',
  credentialId: '',
  inputType: 'auto',
  sourceField: 'content',
  documentName: '',
  chunkSize: 1000,
  chunkOverlap: 200,
  embeddingModel: 'text-embedding-3-small',
  metadata: ''
};
